var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center" },
      [
        _c(
          "h2",
          {
            staticClass: "grey-color font-weight-bold",
            class: `${_vm.headerClass} ${_vm.compact ? "my-1" : "my-3"}`,
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _c(
          "file-uploader",
          {
            staticClass: "fix-pos",
            attrs: { "is-disabled": _vm.isLoading, "is-main": false },
            on: { set_file: _vm.addFile },
          },
          [_vm._v("Загрузить")]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "table-responsive py-2",
        class: _vm.v.$invalid ? "is-invalid" : "",
      },
      [
        _c("table", { staticClass: "table" }, [
          _c("thead", [
            _c("tr", [
              _vm.withNumber
                ? _c(
                    "th",
                    {
                      class: { "py-1": _vm.compact },
                      staticStyle: { width: "1px" },
                    },
                    [_vm._v("№")]
                  )
                : _vm._e(),
              _c("th", { class: { "py-1": _vm.compact } }, [
                _vm._v("Наименование"),
              ]),
              _c("th", {
                class: { "py-1": _vm.compact },
                staticStyle: { width: "1px" },
              }),
            ]),
          ]),
          _c(
            "tbody",
            [
              _vm._l(_vm.documents, function (document, index) {
                return _c("tr", { key: index }, [
                  _vm.withNumber
                    ? _c(
                        "td",
                        {
                          staticClass: "text-nowrap",
                          class: { "py-1": _vm.compact },
                        },
                        [_vm._v(_vm._s(index + 1) + ".")]
                      )
                    : _vm._e(),
                  _c("td", { class: { "py-1": _vm.compact } }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "fs-14 col-form-label d-inline-block atmo-button-link",
                        attrs: {
                          href: _vm.$getAttachmentDownloadLink(document.id),
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(document.name))]
                    ),
                  ]),
                  _c(
                    "td",
                    { class: { "py-1": _vm.compact } },
                    [
                      _c("action-button-small", {
                        attrs: { disabled: _vm.isLoading, icon: "trash" },
                        on: {
                          click: function ($event) {
                            return _vm.removeFile(index, true)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              _vm.documents.length === 0
                ? _c("tr", [
                    _c("td", { attrs: { colspan: "2", align: "center" } }, [
                      _vm._v("Не добавлено документов"),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]
    ),
    _vm.v.$invalid
      ? _c("p", { staticClass: "invalid-feedback" }, [
          _vm._v("Прикрепите документ"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }